import initialState from './initialState'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as getPayments } from './getPayments/reducer'
import { reducer as setFilterPayments } from './setFilterPayments/reducer'
import { reducer as cleanFilterPayments } from './cleanFilterPayments/reducer'
import { reducer as addPayments } from './addPayments/reducer'
import { reducer as goToPaymentsAdministrator } from './goToPaymentsAdministrator/reducer'
import { reducer as continuePayment } from './continuePayment/reducer'
import { reducer as clearUrlPayments } from './clearUrlPayments/reducer'
import { reducer as clearUrlAdministrator } from './clearUrlAdministrator/reducer'
import { reducer as clearErrorMessagePayment } from './clearErrorMessagePayment/reducer'

const reducers = [
    getPayments,
    setFilterPayments,
    cleanFilterPayments,
    addPayments,
    goToPaymentsAdministrator,
    continuePayment,
    clearUrlPayments,
    clearUrlAdministrator,
    clearErrorMessagePayment
];

export default function reducer(state = initialState, action = {}) {
  let newState;
    if (action.type === LOGOUT_USER) {
      // Handle cross-topic actions here
        newState = initialState;
    }
    else {
      newState = state;
    }
  return reducers.reduce((s, r) => r(s, action), newState);
}
